// extracted by mini-css-extract-plugin
export default {"desktopModal":"A6M8YX","content":"W04fOa","buttons":"R9QwtG","primaryButton":"MW0yoI","subtitleContainer":"RJ2pIG","mobile":"YvM6Ib","secondaryButton":"EcQCRy","subtitle":"TAvkpv"};